module.exports = __webpack_public_path__ + "img/cgl_insurance_included.23450aed.svg";